module.exports = __webpack_public_path__ + "img/MS-M-13.c5b94661.svg";